import { ReactComponent as DashboardIcon } from '../assets/icons/dashboard.svg';
import { ReactComponent as WorkflowIcon } from '../assets/icons/workflow.svg';
import { ReactComponent as TemplateIcon } from '../assets/icons/templates.svg';
import { ReactComponent as PortalBuilderIcon } from '../assets/icons/portal-builder.svg';
import { ReactComponent as PromptManagerIcon } from '../assets/icons/rule.svg';

/*export const NAV_LIST = [
    {id:"home",label:"Home",icon:<DashboardIcon />},
    {id:"workflows",label:"Workflows",icon:<WorkflowIcon />},
    {id:"portal",label:"Portal",icon:<TemplateIcon />},
    {id:"portal-builder-templates",label:"Portal Builder Templates",icon:<PortalBuilderIcon />},
    {id:"prompt-manager",label:<span style={{ whiteSpace: "nowrap" }}>Rules & Prompt Manager</span>
    ,icon:<PromptManagerIcon /> },
]*/

export const NAV_LIST = [
  { id: 'home', label: 'Workflows', icon: <WorkflowIcon /> },
  // {id:"portal-builder-templates",label:"Portal Builder Templates",icon:<PortalBuilderIcon />},
  {
    id: 'prompt-manager',
    label: <span style={{ whiteSpace: 'nowrap' }}>Rules & Prompt Manager</span>,
    icon: <PromptManagerIcon />,
  },
];
export const HEADER_HEIGHT = 6.2;
export const THEME = {
  PRIMARY_COLOR: 'var(--primary-color)',
};
export const ALL_STATUS = [
  { id: 'all', label: 'All' },
  { id: 'active', label: 'Active' },
  { id: 'inactive', label: 'Inactive' },
];
export const CATEGORIES = [{ id: 'all', label: 'All Categories' }];

export const CARET_UP_SVG = (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.69031L6.69031 1L12.3806 6.69031"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CARET_DOWN_SVG = (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.30969L6.69031 7L12.3806 1.30969"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SELF_SIGNUP_PAYLOAD = {
  accountStructureId: "2",
  internet: "Internet",
  paper: "Paper",
  personLanguageId: "1",
  personBirthDate: "1994-07-12-00.00.00",
  sendEcareRegistrationEmail: "Y",
  creditClass: "A",
  paymentTerm : {
    standard : "Standard",
    basic: "Basic",
    paymentTermId: "1"
  },
  invoiceChargeMethod: "A",
  ISPinitialPassword: "1234",
  completeSession: "N",
}
